import React, { useRef, useState, useEffect } from "react";

import { Tooltip, Typography, TypographyProps } from "@mui/material";

import { scrollBarSxStyles } from "@/shared/styles";

type PropTypes = TypographyProps & {
  children?: React.ReactNode | undefined | string;
  /**@description Monitored values, the change of which triggers the render of the component */
  depsArray?: unknown[];
};

export const TruncatedWithTooltip: React.FC<PropTypes> = ({
  children,
  depsArray = [],
  ...rest
}) => {
  const typographyRef = useRef<HTMLDivElement | null>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const element = typographyRef.current;
    if (element) {
      const checkOverflow = () => {
        setIsOverflow(element.scrollWidth > element.clientWidth);
      };

      checkOverflow();

      window.addEventListener("resize", checkOverflow);

      return () => {
        window.removeEventListener("resize", checkOverflow);
      };
    }

    return undefined;
  }, [depsArray, children]);

  const content = (
    <Typography
      component={"span"}
      {...rest}
      style={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        verticalAlign: "middle",
      }}
      ref={typographyRef}
    >
      {children}
    </Typography>
  );

  return isOverflow ? (
    <Tooltip
      placement="bottom"
      className="inline min-w-0"
      arrow
      PopperProps={{
        sx: scrollBarSxStyles,
        className: "max-h-screen overflow-auto",
        popperOptions: {
          modifiers: [
            // TODO: MAYBE this will be useful for tooltip to not overlap it's hovered element
            // if that, need to add some more logic for tooltip not be higher than hovered element
            // reference https://popper.js.org/docs/v2/modifiers/prevent-overflow/#altaxis
            //{
            //  name: "flip",
            //  enabled: true,
            //  options: {
            //    altBoundary: true,
            //    rootBoundary: "viewport",
            //    padding: 8,
            //  },
            //},
            {
              name: "preventOverflow",
              enabled: true,
              options: {
                altAxis: true,
                altBoundary: true,
                tether: true,
                rootBoundary: "viewport",
                padding: 8,
              },
            },
          ],
        },
      }}
      title={children}
      enterTouchDelay={0}
      leaveTouchDelay={5000}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};
